import { MainApp } from './components/main-app/main-app'
import { ErrorBoundary } from 'react-error-boundary'
import { UserMessage } from '@Components/common/user-message'

import './app.scss'
import Analytics, { AnalyticEvents } from '@Util/analytics'

window.addEventListener('beforeunload', () => {
  Analytics.track(AnalyticEvents.EXIT_KENO)
})

export const App = () => {
  return (
    <ErrorBoundary
      fallback={
        <UserMessage
          title="Oops! We're on it!"
          message="Sorry about the hiccup! We're working hard to fix things and get you back in the game. Thanks for your patience—we'll be up and running soon!"
        />
      }>
      <MainApp />
    </ErrorBoundary>
  )
}
